import { useQuery } from 'react-query';
import { isInUnavailableFetchDates } from './../../../components/lab/DateRangePicker/useDatePicker/useBlackoutDates/util';
import { useDatePickerI18n } from './../../lab/DateRangePicker/datePickerI18n';
import { formatDate } from '../../../components/lab/utils';
import { END_DATE, START_DATE } from './../../../components/lab/DateRangePicker/useDatePicker';

export type BlackoutDates = {
  departure?: {
    minDate: string;
    maxDate: string;
    validDaysOfWeek: string[];
    includedDates: string[];
    excludedDates: string | { start: string; end: string }[];
  };
  return?: {
    minDate: string;
    maxDate: string;
    validDaysOfWeek: string[];
    includedDates: string[];
    excludedDates: string | { start: string; end: string }[];
  };
  isValidSelectedDepartureDate?: boolean;
  isValidSelectedReturnDate?: boolean;
};

type RouteOptions = {
  selectedOrigin?: string;
  selectedDestination?: string;
  isRoundtrip?: boolean;
  makeQuery?: boolean;
  selectedDepartureDate?: Date;
  selectedReturnDate?: Date;
};

export type FetchBlackoutDates = (options: RouteOptions) => Promise<BlackoutDates>;

export function useBlackoutDates(fetchBlackoutDates: FetchBlackoutDates, options: RouteOptions) {
  const { format = formatDate } = useDatePickerI18n();
  const key = `origin-${options.selectedOrigin}-destination-${options.selectedDestination}-"isRoundtrip"-${options?.isRoundtrip}`;
  let rest = useQuery(key, () => fetchBlackoutDates(options), {
    refetchOnWindowFocus: false,
    staleTime: 86400000,
    enabled: options?.makeQuery ?? false
  });

  if (options?.selectedDepartureDate && rest && rest?.data) {
    rest['data'] = {
      ...rest?.data,
      isValidSelectedDepartureDate: !isInUnavailableFetchDates(
        rest?.data,
        options?.selectedDepartureDate,
        START_DATE,
        format
      )
    };
  }

  if (options?.selectedReturnDate && rest && rest?.data) {
    rest['data'] = {
      ...rest?.data,
      isValidSelectedReturnDate: !isInUnavailableFetchDates(
        rest?.data,
        options?.selectedReturnDate,
        END_DATE,
        format
      )
    };
  }
  return rest;
}
